import $ from 'jquery';

export function setupMultiSelect(selector, postKey, onSelectClearListener, onMultiChangeListener){

  if (!selector){
    return;
  }

  var dataKey = selector.attr("data-key");
  var dataLabel = selector.attr("data-label");

  $(document).on("click", "#" + selector.attr("id") + " .multi-select-item", function(){

    if ($(this).hasClass("active")){
      $(this).removeClass("active")
    } else {
      $(this).addClass("active")
    }

    onMultiChangeListener();
  });

  selector.find("input").keyup(function(){

    const searchValue = $(this).val().toUpperCase();

    if (searchValue === ""){
      selector.find(".multi-select-item").removeClass("hidden");
      return;
    }

    selector.find(".multi-select-item").each(function(){

      const ref = $(this).text().toUpperCase();

      if (ref.indexOf(searchValue) == -1){
        $(this).addClass("hidden");
      } else {
        $(this).removeClass("hidden");
      }

    });

  });

  selector.find("button.clear-all").click(function(){
    clearAll();
  })

  selector.find("button.select-all").click(function(){
    selectAll();
  })

  function getPostData(){

    var data = "";
    if (selector.attr("data-select-all") === true || selector.attr("data-select-all") === "true"){
      data += "&" + postKey + "SelectAll=true";
    }
    
    selector.find(".multi-select-item.active").each(function(){
      data += "&" + postKey + "[]" + "=" + $(this).attr("data-id");
    });

    return data;
  }

  function clearAll(){
    selector.find(".multi-select-item").removeClass("active");
    selector.find("input").val("").trigger("keyup");
    selector.attr("data-select-all", false);
    if (onSelectClearListener){
      onSelectClearListener();
    }
    
  }

  function selectAll(){
    selector.find(".multi-select-item").addClass("active");
    selector.attr("data-select-all", true);
    if (onSelectClearListener){
      onSelectClearListener();
    }
  }

  function setMultiData(data){

    var container = selector.find(".multi-item-container");
    container.html("");

    data.forEach(parent => {

      if (parent.CHILDREN.length === 0){
        return;
      } 

      var header = $("<div></div>");
      header.addClass("flex items-center justify-between bg-white font-bold border-b border-white py-2 multi-select-item-header");
      header.html(parent["PROJ10_REFR"]);

      container.append(header);

      parent.CHILDREN.forEach(group => {

        var item = $("<div></div>");
        item.addClass("flex items-center justify-between bg-neutral-200 border-b border-white hover:bg-sky-200 p-2 multi-select-item cursor-pointer");
        item.attr("data-id", group["PROJ20_ID"]);
        item.html(group["PROJ20_REFR"]);

        container.append(item);

      });
    });

  }

  function hasMultiSelectItems(){
    return selector.find(".multi-select-item").length > 0;
  }

  return {
    getPostData: getPostData,
    setMultiData: setMultiData,
    hasMultiSelectItems: hasMultiSelectItems,
    clearAll: clearAll
  }

}
